import {getLocale, getCurrency} from '@dazn/lp-web/src/utils/dazn/Region';

const localisePrice = (
    price: any,
    currency = getCurrency(),
    locale = getLocale()
):any => {
    if (!price) {
        return;
    }
    const hasDecimal = price % 1 !== 0;

    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency || 'eur',
        minimumFractionDigits: hasDecimal ? 1 : 0,
        maximumFractionDigits: hasDecimal ? 3 : 0,
    });

    let formattedPrice = formatter.format(price);

    // Extract the decimal separator dynamically from the formatted output
    const decimalSeparator = (1.1).toLocaleString(locale).replace(/\d/g, '').trim();

    // Split using the actual decimal separator of the locale
    const parts = formattedPrice.split(decimalSeparator);

    if (parts.length === 2) {
        const [integerPart, fractionalPart] = parts;

        if (/^0+$/.test(fractionalPart)) {
            formattedPrice = integerPart; // Return only the integer part if fractional part is all zeros
        }
    }
    return formattedPrice;
};

export default localisePrice;
